<template>
    <component :is="component">
        <li v-for="(item, key) in data" :key="key">
            <slot :name="`list-item-${key}`" :item="item">
                {{item}}
            </slot>
        </li>
    </component>
</template>
<script>
export default {
    name: 'oc-list',
    props: {
        type: {
            type: String,
            default: '-'
        },
        data: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        component() {
            return this.type === '-' ? 'ol' : 'ul'
        }
    }
}
</script>
